export default __webpack_public_path__ + "static/benefit-3-9b4d9db608e063610b74a68606e78185.jpg";